import clsx from 'clsx';
import InnerHTML from 'dangerously-set-html-content';
import { useScript } from 'hooks/useScript';
import __isEmpty from 'lodash/isEmpty';
import styles from './text.module.scss';

export default function Text(props) {
    const { text, className, estil, mida, tag, idDom, dataTestId } = props;
    const { isJavaScriptClientEnabled } = useScript();

    const stylesText = clsx({
        [styles.text]: true,
        [styles[estil]]: !__isEmpty(estil),
        [styles[mida]]: !__isEmpty(mida),
        [className]: !__isEmpty(className)
    });
    const CustomTag = `${tag}`;

    if (tag === 'div' && isJavaScriptClientEnabled) {
        return <InnerHTML className={stylesText} html={text} {...(idDom && { id: idDom })} data-testid={dataTestId} />;
    } else {
        return (
            <CustomTag
                className={stylesText}
                dangerouslySetInnerHTML={{ __html: text }}
                {...(idDom && { id: idDom })}
                data-testid={dataTestId}
            ></CustomTag>
        );
    }
}

Text.defaultProps = {
    text: '',
    tag: 'div',
    className: null,
    estil: null
};
